const $ = jQuery;
const videoWrapElems = document.querySelectorAll('.wp-block-video');

var video = {
  init() {
    /**
     * Single Video, aka Hero Video
     */
    // var $heroVideo = $('#hero-video');


    videoWrapElems.forEach((videoWrapElem) => {
      // console.log('videoWrapElem');
      // console.log(videoWrapElem);
      // videoWrapElem.addEventListener('loadeddata', () => {
      //   videoWrapElem.parentElement.classList.add('loaded');
      // });


      let videoElem = videoWrapElem.querySelector('video');

      $(videoWrapElem).on('click touchstart', function () {
        if (videoElem.paused) {
          videoElem.play();
        }
        // Check for controls (on/off) as they interfere with our function
        else if (!videoElem.controls && !videoElem.paused) {
          videoElem.pause();
        }
      });

      $(videoElem).on('play', function () {
        $(this).parent().addClass('video-playing');
      }).on('pause', function () {
        $(this).parent().removeClass('video-playing');
      });
    });
  },
};

export default video;



// WEBPACK FOOTER //
// ./scripts/modules/video.js